import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'

/**
 * Every user-facing string routes through t() from day one — retrofitting
 * i18n is the expensive part (UI-RECOMMENDATIONS §2). English-only catalog
 * for now; additional locales plug in here.
 */
void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    // React already escapes rendered values.
    escapeValue: false,
  },
})

export default i18n
